export const defaultGameStats = {
    artifactsCollected: 0,
    gameId: null,
    planetsColonized: 0,
    planetsConquered: 0,
    planetsLost: 0,
    resources: 0,
    score: 0,
    shipsBuilt: 0,
    shipsDestroyed: 0,
    shipsLost: 0,
    victory: false,
}
export const defaultDifficulty = 'difficulty2'
export const defaultBoardSize = 'size2'

const Config = {
    artifacts: {},
    autoSaveInterval: 10000,
    boardSize: defaultBoardSize,
    boardSizes: {
        size1: {
            artifactCount: 3,
            blitterStarCount: 2000,
            boardWidth: 1100,
            boardHeight: 1100,
            planetCount: 9,
            starCountMax: 2,
            starCountMin: 1,
        },
        size2: {
            artifactCount: 4,
            blitterStarCount: 3200,
            boardWidth: 1300,
            boardHeight: 1300,
            planetCount: 12,
            starCountMax: 2,
            starCountMin: 1,
        },
        size3: {
            artifactCount: 5,
            blitterStarCount: 3400,
            boardWidth: 1500,
            boardHeight: 1500,
            planetCount: 15,
            starCountMax: 3,
            starCountMin: 1,
        },
        // size4: {
        //     artifactCount: 5,
        //     blitterStarCount: 3600,
        //     boardWidth: 1700,
        //     boardHeight: 1700,
        //     planetCount: 20,
        //     starCountMax: 4,
        //     starCountMin: 1,
        // },
    },
    boardPadding: 200,
    careerStats: {
        artifactsCollected: 0,
        planetsColonized: 0,
        planetsConquered: 0,
        planetsLost: 0,
        score: 0,
        shipsBuilt: 0,
        shipsDestroyed: 0,
        shipsLost: 0,
        victories: 0,
        losses: 0,
    },
    colorRed: 'ca242f',
    colorGreen: '77cf0f',
    colorBlue: '00aeef',
    colorOrange: 'ffbe0b',
    difficulty: defaultDifficulty,
    difficultyLevels: {
        difficulty1: {
            enemyMoveInterval: 10000,
            enemySatelliteMax: 1,
            enemyShipCount: 1,
            enemyShipHealRate: 0.03,
            enemyShipHealOrbitRate: 0.04,
            enemyShipMax: 8,
            enemyShipSpeed: 0.5,
            enemyShipWeaponSpeed: 500,
            enemyShipWeaponDamage: [1, 2, 3, 4],
            planetTowablePoints: 50,
            planetColonizeTime: 5000,
            planetColonizePoints: 15,
            planetConquerPoints: 25,
            planetDiscoverPoints: 5,
            planetMineBuildTime: 5000,
            planetMineBuildPoints: 15,
            planetMineResourceCost: 50,
            planetMineResourceRate: 5,
            planetMineResourceDelay: 10000,
            planetResourceBonus: 50,
            planetSensorRange: 200,
            resources: 600,
            satelliteBuildTime: 2000,
            satelliteResourceCost: 50,
            satelliteResourceDisbandSalvage: 40,
            satelliteSensorRange: 200,
            shipBuildTime: 4000,
            shipDestroyPoints: 20,
            shipHitTowablePoints: 20,
            shipProximityRange: 90,
            shipResourceCost: 100,
            shipResourceDisbandSalvage: 90,
            shipResourceSalvage: 25,
            userShipCount: 3,
        },
        difficulty2: {
            enemyMoveInterval: 8000,
            enemySatelliteMax: 1,
            enemyShipCount: 3,
            enemyShipHealRate: 0.03,
            enemyShipHealOrbitRate: 0.04,
            enemyShipMax: 9,
            enemyShipSpeed: 0.55,
            enemyShipWeaponSpeed: 500,
            enemyShipWeaponDamage: [1, 2, 3, 4],
            planetTowablePoints: 55,
            planetColonizeTime: 6000,
            planetColonizePoints: 20,
            planetConquerPoints: 30,
            planetDiscoverPoints: 10,
            planetMineBuildTime: 6000,
            planetMineBuildPoints: 20,
            planetMineResourceCost: 50,
            planetMineResourceRate: 5,
            planetMineResourceDelay: 15000,
            planetResourceBonus: 50,
            planetSensorRange: 200,
            resources: 400,
            satelliteBuildTime: 2500,
            satelliteResourceCost: 50,
            satelliteResourceDisbandSalvage: 35,
            satelliteSensorRange: 200,
            shipBuildTime: 5000,
            shipDestroyPoints: 25,
            shipHitTowablePoints: 25,
            shipProximityRange: 90,
            shipResourceCost: 100,
            shipResourceDisbandSalvage: 85,
            shipResourceSalvage: 25,
            userShipCount: 2,
        },
        difficulty3: {
            enemyMoveInterval: 5000,
            enemySatelliteMax: 1,
            enemyShipCount: 6,
            enemyShipHealRate: 0.03,
            enemyShipHealOrbitRate: 0.04,
            enemyShipMax: 10,
            enemyShipSpeed: 0.6,
            enemyShipWeaponSpeed: 500,
            enemyShipWeaponDamage: [1, 2, 3, 4],
            planetTowablePoints: 60,
            planetColonizeTime: 7000,
            planetColonizePoints: 25,
            planetConquerPoints: 35,
            planetDiscoverPoints: 15,
            planetMineBuildTime: 7000,
            planetMineBuildPoints: 25,
            planetMineResourceCost: 50,
            planetMineResourceRate: 5,
            planetMineResourceDelay: 15000,
            planetResourceBonus: 50,
            planetSensorRange: 280,
            resources: 200,
            satelliteBuildTime: 3000,
            satelliteResourceCost: 50,
            satelliteResourceDisbandSalvage: 30,
            satelliteSensorRange: 200,
            shipBuildTime: 6000,
            shipDestroyPoints: 30,
            shipHitTowablePoints: 30,
            shipProximityRange: 90,
            shipResourceCost: 100,
            shipResourceDisbandSalvage: 80,
            shipResourceSalvage: 25,
            userShipCount: 1,
        },
    },
    enemyFactions: [],
    enemyFactionName: 'opfor',
    entities: {},
    entityPreviewHolderId: 'entity-preview-holder',
    entityPlaceholderRadius: 70,
    entityPlaceholderCollisonAttempts: 50,
    gameStats: defaultGameStats,
    isGameLoading: false,
    isGameOver: false,
    isResetting: false,
    isSelectingShips: false,
    isDemo: false,
    moveLineAlpha: 0.5,
    moveLineSelectedAlpha: 0.7,
    moveMarkerAlpha: 0.8,
    moveMarkerSelectedAlpha: 1,
    orbitDistance: 50,
    planetCollisions: {},
    planetMaxSize: 15,
    planetMinSize: 8,
    planetSpacing: 80,
    pointAnimDelay: 600,
    pointAnimDuration: 1500,
    satelliteMax: 1,
    scene: {},
    selectedShips: {},
    selectedTowableId: null,
    shipFormations: {},
    shipMax: 10,
    shipMaxHealth: 100,
    shipMaxTowables: 99,
    shipRanks: {
        rank0: {
            satelliteProximityRange: 95,
            shipHealRate: 0.03,
            shipHealOrbitRate: 0.06,
            shipProximityRange: 90,
            shipSensorRange: 200,
            shipSpeed: 0.7,
            shipWeaponSpeed: 500,
            shipWeaponDamage: [1, 2, 3, 4],
        },
        rank1: {
            satelliteProximityRange: 97,
            shipHealRate: 0.032,
            shipHealOrbitRate: 0.062,
            shipProximityRange: 92,
            shipSensorRange: 205,
            shipSpeed: 0.72,
            shipWeaponSpeed: 495,
            shipWeaponDamage: [2, 3, 4, 5],
        },
        rank2: {
            satelliteProximityRange: 100,
            shipHealRate: 0.034,
            shipHealOrbitRate: 0.064,
            shipProximityRange: 95,
            shipSensorRange: 210,
            shipSpeed: 0.74,
            shipWeaponSpeed: 490,
            shipWeaponDamage: [3, 4, 5, 6],
        },
        rank3: {
            satelliteProximityRange: 105,
            shipHealRate: 0.04,
            shipHealOrbitRate: 0.07,
            shipProximityRange: 100,
            shipSensorRange: 215,
            shipSpeed: 0.76,
            shipWeaponSpeed: 485,
            shipWeaponDamage: [4, 5, 6, 7],
        },
    },
    ships: {},
    namespace: '_ge',
    timers: {},
    towables: {},
    userFactionName: 'user',
    zoomDefault: 1.25,
    zoomDefaultTime: 1000,
    zoomStep: 0.25,
    zoomMax: 2,
    zoomMin: 0.6,
}

export default Config
